<template>
  <Layout class="road-bg">
    <!-- Lets Begin Modal -->
    <Start ref="startup" v-show="showStartUp" :show="showStartUp" @loadDashboard="loadDashboard" class="fadein"></Start>

    <div v-show="!showStartUp">
      <!-- Page Header -->
      <PageHeader :title="pageTitle" />
      <div class="row">
        <!-- LOCATION INFORMATION -->
        <div class="col-xl-3">
          <div class="card bg-soft bg-primary">
            <div class="text-white p-3">
              <h4 class="text-white">
                {{
                  String(
                    dashboardData.statistics.location.location_name
                  ).substr(0, 20)
                }}..
              </h4>
              <p>{{ dashboardData.statistics.location.description }}</p>
              <ul class="ps-3 mb-0">
                <li class="py-1">
                  Distance: {{ dashboardData.statistics.location.distance }} KM
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- STATISTICS -->
        <div class="col-sm-3" @click="$router.push('/incident/atcc-monitor')" style="cursor: pointer">
          <div class="card">
            <div class="card-body">
              <p class="text-muted mb-1">
                <i class="mdi mdi-train-car h2 text-info align-middle mb-0 me-1"></i>
                {{ $t("menuitems.dashboards.list.totalIncident") }}
              </p>

              <div class="row">
                <div class="col-7">
                  <div v-if="dashboardData.statistics.incidentsCount">
                    <h4 class="text-info">
                      {{ dashboardData.statistics.incidentsCount }}
                    </h4>
                    <p class="text-muted text-truncate mb-0">
                      As of {{ GetCurrentMonth() }}
                      {{ new Date().getFullYear() }}
                    </p>
                  </div>
                  <div v-else>
                    <widget-loader />
                  </div>
                </div>
                <div class="col-5">
                  <div>
                    <apexchart class="apex-charts" height="40" type="area" dir="ltr" :series="totalIncidentsChart.series"
                      :options="totalIncidentsChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3" @click="$router.push('/incident/vsds-incidents')" style="cursor: pointer">
          <div class="card">
            <div class="card-body">
              <p class="text-muted mb-1">
                <i class="mdi mdi-billiards-rack h2 text-warning align-middle mb-0 me-1"></i>
                {{ $t("menuitems.dashboards.list.totalSpeedViolations") }}
              </p>

              <div class="row">
                <div class="col-7">
                  <div v-if="dashboardData.statistics.violationsCount || dashboardData.statistics.violationsCount === 0">
                    <h4 class="text-warning">
                      {{ dashboardData.statistics.violationsCount }}
                    </h4>
                    <p class="text-muted text-truncate mb-0">
                      As of {{ GetCurrentMonth() }}
                      {{ new Date().getFullYear() }}
                    </p>
                  </div>
                  <div v-else>
                    <widget-loader />
                  </div>
                </div>
                <div class="col-5">
                  <div>
                    <apexchart class="apex-charts" height="40" type="area" dir="ltr" :series="totalViolationsChart.series"
                      :options="totalViolationsChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3" @click="$router.push('/incident/accidents')" style="cursor: pointer">
          <div class="card">
            <div class="card-body">
              <p class="text-muted mb-1">
                <i class="mdi mdi-car-info h2 text-danger align-middle mb-0 me-1"></i>
                {{ $t("menuitems.dashboards.list.totalAccidents") }}
              </p>

              <div class="row">
                <div class="col-7">
                  <div v-if="dashboardData.statistics.accidentsCount || dashboardData.statistics.accidentsCount === 0">
                    <h4 class="text-danger">
                      {{ dashboardData.statistics.accidentsCount }}
                    </h4>
                    <p class="text-muted text-truncate mb-0">
                      As of {{ GetCurrentMonth() }}
                      {{ new Date().getFullYear() }}
                    </p>
                  </div>
                  <div v-else>
                    <widget-loader />
                  </div>
                </div>
                <div class="col-5">
                  <div>
                    <apexchart class="apex-charts" height="40" type="area" dir="ltr" :series="totalChallansChart.series"
                      :options="totalChallansChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-6">
          <GoogleMap />
        </div>

        <div class="col-xl-6">
          <div class="row">
            <div class="col-6">
              <TrafficDetails></TrafficDetails>
            </div>
            <div class="col-6">
              <IncidentAlerts></IncidentAlerts>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <WeatherStat></WeatherStat>
            </div>
            <div class="col-6">
              <DeviceStats></DeviceStats>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapActions } from "vuex";
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "./page-header";
import Start from "./start.vue";
// import MapMyIndia from "../../components/dashboard/map.vue";
import GoogleMap from "../../components/dashboard/google-map.vue";
import WeatherStat from "@/components/dashboard/weather";
import DeviceStats from "@/components/dashboard/device-stats";
import IncidentAlerts from "@/components/dashboard/incident-alerts";
import TrafficDetails from "@/components/dashboard/traffic-details";
// import ManualAlerts from "@/components/dashboard/manual-alerts";
import Utils from "@/mixins/utils";
import AdminMixin from "@/mixins/administration";
import IncidentMixin from "@/mixins/incident";
import GisMixin from "@/mixins/gis";
import DevicesStackedBar from "../../components/dashboard/devices-stacked-bar.vue";
import widgetLoader from "@/components/widgets/widget-loader";

import {
  totalIncidentsChart,
  totalViolationsChart,
  totalChallansChart,
} from "./data";
import WidgetLoader from "../../components/widgets/widget-loader.vue";

export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [Utils, AdminMixin, GisMixin, IncidentMixin],
  components: {
    Layout,
    PageHeader,
    WeatherStat,
    DeviceStats,
    Start,
    IncidentAlerts,
    // ManualAlerts,
    TrafficDetails,
    // MapMyIndia,
    GoogleMap,
    DevicesStackedBar,
    widgetLoader,
  },
  data () {
    return {
      totalIncidentsChart: totalIncidentsChart,
      totalViolationsChart: totalViolationsChart,
      totalChallansChart: totalChallansChart,
      showStartUp: false,
      socketInterval: null,
    };
  },
  methods: {
    ...mapActions("gis", ["setLocation"]),
    loadDashboard () {
      this.showStartUp = false;
      this.$refs["startup"].$el.classList.value =
        this.$refs["startup"].$el.classList.value + "fadeout";
      this.$router.go();
    },
  },
  beforeDestroy () {
    if (this.socketInterval) {
      clearInterval(this.socketInterval);
      this.socketInterval = null;
    }
  },
  async mounted () {
    try {
      await this.GetAllMasterData();

      const location = await this.GetLocationDetails();
      if (!location) {
        this.showStartUp = true;
      } else {
        this.$store.dispatch("gis/setLocation", {
          id: location.id,
          name: location.location_name,
          description: location.description,
          distance: location.distance,
          startLatitude: location.start_lat,
          startLongitude: location.start_long,
          centerLatitude: location.center_lat,
          centerLongitude: location.center_long,
          endLatitude: location.end_lat,
          endLongitude: location.end_long,
        });

        const devices = await this.GetAllDevices();
        this.$store.dispatch("gis/setDevices", devices);

        this.$socket.emit("REQUEST:DASHBOARD_STATISTICS");
        this.socketInterval = setInterval(() => {
          this.$socket.emit("REQUEST:DASHBOARD_STATISTICS");
        }, 30000);
      }
    } catch (e) {
      console.error(e);
      swal.fire("Master API Error", "Failed to fetch master data", "error");
    }
  },
  computed: {
    dashboardData () {
      return this.$store.getters["socket/dashboard"];
    },
    gisLocation () {
      return this.$store.getters["gis/location"];
    },
    pageTitle () {
      return this.gisLocation
        ? this.gisLocation.name + " Statistics"
        : "ATMS Dashboard";
    },
  },
};
</script>

<style scoped>
/* @import url("https://js.arcgis.com/3.40/esri/css/esri.css"); */

.fadein {
  visibility: visible;
  opacity: 1;
  transition: opacity 4s linear;
}

.fadeout {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 6s, opacity 6s linear;
}

/* .road-bg {
  background: linear-gradient(rgba(21, 21, 21, 0.8), rgba(43, 43, 43, 0.8)),
    url("../../assets/images/road-bg.jpeg");
  background-repeat: no-repeat, repeat;
  background-position: center;
  background-size: cover;
} */
</style>
